<div class="kEntriesTable" [class.noResults]="!_entries?.length" [class.kTagsVisible]="isTagsBarVisible">
  <p-table
    [scrollable]="true"
    scrollHeight="100%"
    [value]="_entries"
    dataKey="id"
    [rowTrackBy]="_rowTrackBy"
    [sortField]="sortField"
    [sortOrder]="sortOrder"
    [resizableColumns]="true"
    [defaultSortOrder]="_defaultSortOrder"
    (sortFunction)="_onSortChanged($event)"
    [customSort]="true"
    (onColResize)="_columnsResizeManager.onColumnResize($event)"
    [(selection)]="selectedEntries"
    (selectionChange)="_onSelectionChange($event)"
    kStickyHeader
    [sticksTo]="'entriesTags'"
    stickyClass="stickyHeader"
    [stickyId]="'entriesTable'"
  >
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col style="width: 44px; padding-left: 13px" *ngIf="showBulkSelect" />
        <col
          data-cid="thumbnailUrl"
          *ngIf="
            _columnsMetadata.thumbnailUrl && !(_kmcPermissions.FEATURE_DISABLE_KMC_LIST_THUMBNAILS | kNgIfPermitted)
          "
          [ngStyle]="_columnsMetadata.thumbnailUrl.style"
        />
        <col data-cid="name" *ngIf="_columnsMetadata.name" [ngStyle]="_columnsMetadata.name.style" />
        <col data-cid="id" *ngIf="_columnsMetadata.id" [ngStyle]="_columnsMetadata.id.style" />
        <col data-cid="mediaType" *ngIf="_columnsMetadata.mediaType" [ngStyle]="_columnsMetadata.mediaType.style" />
        <col
          data-cid="moderationCount"
          *ngIf="_columnsMetadata.moderationCount"
          [ngStyle]="_columnsMetadata.moderationCount.style"
        />
        <col data-cid="createdAt" *ngIf="_columnsMetadata.createdAt" [ngStyle]="_columnsMetadata.createdAt.style" />
        <col
          data-cid="moderationStatus"
          *ngIf="_columnsMetadata.moderationStatus"
          [ngStyle]="_columnsMetadata.moderationStatus.style"
        />
        <col data-cid="duration" *ngIf="_columnsMetadata.duration" [ngStyle]="_columnsMetadata.duration.style" />
        <col data-cid="plays" *ngIf="_columnsMetadata.plays" [ngStyle]="_columnsMetadata.plays.style" />
        <col data-cid="status" *ngIf="_columnsMetadata.status" [ngStyle]="_columnsMetadata.status.style" />
        <col data-cid="rowActions" *ngIf="rowActions?.length" style="width: 80px" />
        <col
          data-cid="addToBucket"
          *ngIf="_columnsMetadata.addToBucket"
          [ngStyle]="_columnsMetadata.addToBucket.style"
        />
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th [ngStyle]="{ width: '44px', 'padding-left': '13px' }" *ngIf="showBulkSelect">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th
          data-cid="thumbnailUrl"
          pResizableColumn
          [ngStyle]="_columnsMetadata.thumbnailUrl.style"
          *ngIf="
            _columnsMetadata.thumbnailUrl && !(_kmcPermissions.FEATURE_DISABLE_KMC_LIST_THUMBNAILS | kNgIfPermitted)
          "
        >
          {{ 'applications.content.table.thumbnail' | translate }}
        </th>
        <th
          data-cid="name"
          pResizableColumn
          [ngStyle]="_columnsMetadata.name.style"
          *ngIf="_columnsMetadata.name"
          [kpSortableColumn]="_columnsMetadata.name.sortable ? 'name' : null"
        >
          {{ 'applications.content.table.name' | translate }}
          <p-sortIcon [field]="'name'"></p-sortIcon>
        </th>
        <th data-cid="id" pResizableColumn [ngStyle]="_columnsMetadata.id.style" *ngIf="_columnsMetadata.id">
          {{ 'applications.content.table.id' | translate }}
        </th>
        <th
          data-cid="mediaType"
          pResizableColumn
          [ngStyle]="_columnsMetadata.mediaType.style"
          *ngIf="_columnsMetadata.mediaType"
          [kpSortableColumn]="_columnsMetadata.mediaType.sortable ? 'mediaType' : null"
        >
          {{ 'applications.content.table.type' | translate }}
          <p-sortIcon [field]="'mediaType'"></p-sortIcon>
        </th>
        <th
          data-cid="moderationCount"
          pResizableColumn
          [ngStyle]="_columnsMetadata.moderationCount.style"
          *ngIf="_columnsMetadata.moderationCount"
          [kpSortableColumn]="_columnsMetadata.moderationCount.sortable ? 'moderationCount' : null"
        >
          {{ 'applications.content.table.flags' | translate }}
          <p-sortIcon [field]="'moderationCount'"></p-sortIcon>
        </th>
        <th
          data-cid="createdAt"
          pResizableColumn
          [ngStyle]="_columnsMetadata.createdAt.style"
          *ngIf="_columnsMetadata.createdAt"
          [kpSortableColumn]="_columnsMetadata.createdAt.sortable ? 'createdAt' : null"
        >
          {{ 'applications.content.table.createdOn' | translate }}
          <p-sortIcon [field]="'createdAt'"></p-sortIcon>
        </th>
        <th
          data-cid="moderationStatus"
          pResizableColumn
          [ngStyle]="_columnsMetadata.moderationStatus.style"
          *ngIf="_columnsMetadata.moderationStatus"
        >
          {{ 'applications.content.table.moderationStatus' | translate }}
        </th>
        <th
          data-cid="duration"
          pResizableColumn
          [ngStyle]="_columnsMetadata.duration.style"
          *ngIf="_columnsMetadata.duration"
          [kpSortableColumn]="_columnsMetadata.duration.sortable ? 'duration' : null"
        >
          {{ 'applications.content.table.duration' | translate }}
          <p-sortIcon [field]="'duration'"></p-sortIcon>
        </th>
        <th
          data-cid="plays"
          pResizableColumn
          [ngStyle]="_columnsMetadata.plays.style"
          *ngIf="_columnsMetadata.plays"
          [kpSortableColumn]="_columnsMetadata.plays.sortable ? 'plays' : null"
        >
          {{ 'applications.content.table.plays' | translate }}
          <p-sortIcon [field]="'plays'"></p-sortIcon>
        </th>
        <th
          data-cid="status"
          pResizableColumn
          [ngStyle]="_columnsMetadata.status.style"
          *ngIf="_columnsMetadata.status"
        >
          {{ 'applications.content.table.status' | translate }}
        </th>
        <th data-cid="rowActions" id="rowActions" *ngIf="rowActions?.length"></th>
        <th data-cid="addToBucket" id="addToBucket" *ngIf="_columnsMetadata.addToBucket"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-entry>
      <tr [pSelectableRow]="entry">
        <td [ngStyle]="{ width: '44px', 'padding-left': '13px' }" *ngIf="showBulkSelect">
          <p-tableCheckbox [value]="entry"></p-tableCheckbox>
        </td>

        <td
          class="ui-resizable-column"
          *ngIf="
            _columnsMetadata.thumbnailUrl && !(_kmcPermissions.FEATURE_DISABLE_KMC_LIST_THUMBNAILS | kNgIfPermitted)
          "
        >
          <div
            class="kThumbnailHolder"
            #holder
            [class.disable]="!_allowDrilldown('view', entry.mediaType, entry.status)"
            (click)="_onActionSelected('view', entry)"
          >
            <img
              *ngIf="entry.thumbnailUrl"
              [src]="entry.thumbnailUrl"
              onError="this.onerror=null;this.style.display='none'"
              (error)="thumbks.src = entry.thumbnailUrl + '/ks/' + _ks"
            />
            <img
              #thumbks
              onError="this.onerror=null;this.style.display='none'"
              (error)="holder.classList.add('error')"
            />
            <div class="kIcons">
              <!--i class="kIconwarning"></i-->
              <i
                class="kIconyoutube kThumbnailTypeIcon"
                *ngIf="entry.externalSourceType === _youtubeExternalSourceType"
              ></i>
              <i class="kIconquiz kThumbnailTypeIcon" *ngIf="entry.isQuizEntry"></i>
            </div>
          </div>
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.name">
          <span
            class="kTitle kTableColumn"
            [kTooltip]="entry.name"
            [showOnEllipsis]="true"
            [class.disable]="!_allowDrilldown('view', entry.mediaType, entry.status)"
            (click)="_onActionSelected('view', entry)"
          >
            {{ entry.name }}
          </span>
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.id">
          <span class="kTableColumn" [kTooltip]="entry.id" [showOnEllipsis]="true">{{ entry.id }}</span>
        </td>

        <td class="ui-resizable-column kMediaTypeIcon" *ngIf="_columnsMetadata.mediaType">
          <div [kTooltip]="entry.mediaType | entryType: true" [class]="entry.mediaType | entryType: false"></div>
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.moderationCount">
          {{ entry.moderationCount }}
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.createdAt">
          <span class="kTableColumn" [kTooltip]="entry.createdAt | kmcDate" [showOnEllipsis]="true">
            {{ entry.createdAt | kmcDate }}
          </span>
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.moderationStatus">
          <span class="kTableColumn" [kTooltip]="entry.moderationStatus | kModerationStatus" [showOnEllipsis]="true">
            {{ entry.moderationStatus | kModerationStatus }}
          </span>
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.duration">
          <span class="kTableColumn" [kTooltip]="entry.duration | kTime | entryDuration: entry" [showOnEllipsis]="true">
            {{ entry.duration | kTime | entryDuration: entry }}
          </span>
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.plays">
          {{ entry.plays }}
        </td>

        <td class="ui-resizable-column" *ngIf="_columnsMetadata.status">
          <span class="kTableColumn" [kTooltip]="entry | entryStatus" [showOnEllipsis]="true">
            {{ entry | entryStatus }}
          </span>
        </td>

        <td *ngIf="rowActions?.length">
          <div class="kEntriesTableActions">
            <button
              type="button"
              pButton
              class="kMoreActionsButton"
              icon="kIconmore"
              (click)="_openActionsMenu($event, entry)"
            ></button>
          </div>
        </td>

        <td *ngIf="_columnsMetadata.addToBucket">
          <div class="kEntriesTableActions">
            <button
              type="button"
              pButton
              class="kButtonDefault kButtonAddToBucket"
              label="+"
              (click)="_onActionSelected('addToBucket', entry)"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <div class="emptymessage">
        <div class="kEmptyMessage">{{ _emptyMessage }}</div>
      </div>
    </ng-template>
  </p-table>
</div>
